import {Component, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';
import {EMPTY_FAVORITE, EMPTY_USER, PRICE_EVOL_LEGENT} from '@models/empty';
import {User} from '@models/user';
import {PdfConfig} from '@models/pdf';
import {environment} from '~/environments/environment';
import {CityService} from '@services/city.service';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {AdService} from '@services/ad.service';
import {UserService} from '@services/user.service';
import {AuthenticationService} from '@services/authentification.service';
import {MatDialog} from '@angular/material/dialog';
import {AlertService} from '@services/alert.service';
import {TrackingService} from '@services/tracking.service';
import * as htmlToImage from 'html-to-image';
import {jsPDF} from 'jspdf';
import * as $ from 'jquery';
import * as _ from 'underscore';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';

@Component({
    selector: 'app-purple',
    templateUrl: './purple.component.html',
    styleUrls: ['./purple.component.scss']
})
export class PurpleComponent implements OnInit {

    favorite: Favorite = Object.assign({}, EMPTY_FAVORITE);
    user: User = Object.assign({}, EMPTY_USER);
    pdfConfig: PdfConfig;

    fontSize = 24;

    params;
    result: any[] = [];
    displayedColumns: string[] = [];
    amort_moy = 0;
    apiUrl = environment.apiUrl;
    hideUnit = false;
    imgDone: string[] = [];
    imgAnnonce = '';
    imgEmplacement = '';
    imgDistance = '';
    imgCopro = '';
    imgSecteur = '';
    imgFinance = '';
    imgPhoto = '';
    imgPhoto2 = '';
    imgPhoto3 = '';
    imgPhoto4 = '';
    imgLivraison = '';
    imgLivraison2 = '';
    imgResume = '';
    imgFinal = '';
    imgPatrimoniale = '';
    ready = false;
    loading = false;
    enrichment = 0;
    enrichment_10 = 0;

    data_CF_cum = [];

    advice_price = 0;
    rand = Math.floor(Date.now() / 1000);

    stripe = Stripe(environment.stripeKey);

    distance_1 = 'à 10 min';
    distance_1_text = 'du centre ville de Lyon';
    distance_2 = '';
    distance_2_text = '';
    distance_3 = '';
    distance_3_text = '';

    photo_1 = 0;
    photo_2 = 0;
    photo_3 = 0;
    photo_4 = 0;
    photo_5 = 0;
    photo_6 = 0;
    photo_7 = 0;
    photo_8 = 0;

    /**
     * Chart repartition
     */
    chargeEchartsIntance = null;
    chargeOptions = {
        // tooltip: {
        //     trigger: 'item',
        //     formatter: '{c}€ ({d}%)'
        // },
        legend: {
            orient: 'vertical',
            right: '0px',
            top: '30px',
            align: 'right',
            textStyle: {
                fontSize: 14,
            },
        },
        calculable: true,
    };
    chargeData = {
        series: []
    };

    /**
     * Chart price evol
     */
    priceEvolEchartsIntance = null;
    priceEvolOptions = {
        legend: {
            orient: 'vertical',
            right: '20px',
            bottom: '40px',
            align: 'right',
            selected: {},
        },
        grid: {
            left: '1%',
            right: '3%',
            top: '10',
            bottom: '15',
            containLabel: true,
        },
        xAxis: {
            data: [],
            axisLabel: {
                fontSize: 12
            }
        },

        yAxis: {
            type: 'value',
            label: {
                formatter: '{b} <br/>{a} : {c} €/m²',
            },
            min: 10000,
            axisLabel: {
                formatter: '{value} €/m²',
                fontSize: 12
            }
        },
        color: ['#2980B9', '#8E44AD ', '#C0392B', '#E67E22'],
        series: []
    };
    priceEvolData = {
        series: [],
    };


    // Graphique évolution de la population
    popEchartsIntance = null;
    popOptions = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: '{a} <br/>{b} : {c}'
        },
        grid: [{
            left: '10px',
            right: '10px',
            top: '10px',
            bottom: '20px',
            containLabel: true
        }],
        xAxis: {
            type: 'category',
            data: [],
            axisTick: {
                alignWithLabel: true,
            },
        },

        yAxis: {
            type: 'value',
            min: 1000000,
        },
        color: ['#5FB761'],

        series: []

    };
    popData = {
        series: [],
    };

    // Contact
    pro_data = {
        mobile: '',
    };
    title = '';
    sub_title = '';

    constructor(
        public cityService: CityService,
        private http: HttpClient,
        private route: ActivatedRoute,
        private adService: AdService,
        private userService: UserService,
        public authenticationService: AuthenticationService,
        public dialog: MatDialog,
        private alertService: AlertService,
        public trackingService: TrackingService,
        private router: Router) {
    }

    ngOnInit(): void {
        this.pdfConfig = {
            societe: '',
            template: ['classique'],
            logo_w: 557,
            logo_h: 211,
            logo_url: 'assets/pdf/purpleimmobilier/LOGO purple.png',
            logo_small_w: 557,
            logo_small_h: 211,
            logo_small_url: 'assets/pdf/purpleimmobilier/logo purple 2.png',
            logo_small_style: '',
            display_legal_notice: true,
            display_note: false,
            display_contact: true,
            contact_bkg: '#000',
            h2_class: 'underline',
            h2_underline_url: '',
            h3_class: '',
            font_family: 'Barlow',
            text_color: '#000',
            second_color: '#000',
            visuel_1: '',
            visuel_1b: '',
            visuel_2: '',
            visuel_3: '',
            color_kpi_1: '#520C82',
            color_kpi_2: '#520C82',
            color_kpi_3: '#520C82',
            color_kpi_4: '#520C82',
            color_kpi_5: '#520C82',
            contact_tpl: 'agence',
            contact_visuel: '',
            contact: `<b>purple Impact</b><br/>
                            3, rue Meyerbeer<br/>
                            75009 Paris<br/>
                            <br/>
                            Tél : 01 85 09 50 73`,
            marque_blanche: false,
        };

        let css = `
                #book * {
                    font-family: '` + this.pdfConfig.font_family + `-Regular';
                    color: ` + this.pdfConfig.text_color + `;
                }
                #book textarea {
                    color: #343a40;
                }
                #book .bilan_comptable td  {
                    font-family: 'arial';
                }
                #book .contact * {
                    color: white;
                }
                #book .text-color {
                    color: ` + this.pdfConfig.text_color + ` !important;
                }
                #book .title input {
                    font-family: '` + this.pdfConfig.font_family + `-Medium';
                    color: ` + this.pdfConfig.text_color + `;
                }
                #book h2 {
                    font-family: '` + this.pdfConfig.font_family + `-Medium';
                }
                #book .card .card-header .card-title h3 {
                    font-family: '` + this.pdfConfig.font_family + `-Regular';
                }
                #book .block.card label {
                    font-family: "` + this.pdfConfig.font_family + `-Regular";
                }
                #book .block_recap table td {
                    font-family: "` + this.pdfConfig.font_family + `-Light";
                }
                #book .block_recap table th, #book .block_recap table th > div, #book .block_recap table th > div > span {
                    font-family: "` + this.pdfConfig.font_family + `-Regular";
                }
                #book .desc, #book .desc textarea {
                    font-family: "` + this.pdfConfig.font_family + `-Light";
                }
                #book .notes, #book .notes textarea {
                    font-family: "` + this.pdfConfig.font_family + `-Light";
                }
                #book .contact {
                    background-color: ` + this.pdfConfig.contact_bkg + `;
                }
                #book .contact .col-md-6 {
                    font-family: "` + this.pdfConfig.font_family + `-Light";
                }
                #book .contact .col-md-6 b {
                    font-family: "` + this.pdfConfig.font_family + `-SemiBold";
                    color: #BD8143;
                    display: block;
                }
                #book h2.underline::after {
                    border-color: ` + this.pdfConfig.second_color + ` !important;
                }
                .kpi-color-1 {
                    background-color: ` + this.pdfConfig.color_kpi_1 + `;
                }
                .kpi-color-2 {
                    background-color: ` + this.pdfConfig.color_kpi_2 + `;
                }
                .kpi-color-3 {
                    background-color: ` + this.pdfConfig.color_kpi_3 + `;
                }
                .kpi-color-4 {
                    background-color: ` + this.pdfConfig.color_kpi_4 + `;
                }
                .kpi-color-5 {
                    background-color: ` + this.pdfConfig.color_kpi_5 + `;
                }
            `;

        const head = document.getElementsByTagName('head')[0];
        const style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(css));
        head.appendChild(style);

        this.user = this.authenticationService.currentUser;

        if (this.user.pro_data === '') {
            this.alertService.error('Veuillez renseigner les informations de votre agences dans la partie "Mon compte"');
        } else {
            this.pro_data = JSON.parse(this.user.pro_data);
        }

        const available_page = ['annonce', 'emplacement', 'distance', 'secteur', 'copro', 'photo', 'photo2', 'photo3', 'photo4', 'livraison', 'livraison2', 'finance', 'resume', 'final'];
        if (this.user.user_dashboard.pdf_profil == '') {
            this.user.user_dashboard.pdf_profil = 'classique';
            this.user.user_dashboard.pdf_quality = 'normal';
            this.user.user_dashboard.pdf_page = available_page;
        } else {
            let page = [];
            this.user.user_dashboard.pdf_page.forEach(keys => {
                if (available_page.includes(keys)) {
                    page.push(keys);
                }
            });
            this.user.user_dashboard.pdf_page = page;
        }

        this.route.parent.params.subscribe(params => {
            this.params = params;

            let id = params.favoriteId;
            if (this.router.url.includes('/app/annonces/')) {
                id = params.id;
            }

            this.adService.getFavorite(id).subscribe(result => {
                this.favorite = this.adService.updateValues(result);

                this.setPriceEvolData();
                this.setChargeData();
                this.setPopData();
                this.callImpot();

                if (this.favorite.ad.real_estate_type == 'immeuble' || this.favorite.nb_lots > 1 || this.favorite.lots.length > 1) {
                    let lot = this.favorite.lots.length;
                    if (this.favorite.nb_lots >= this.favorite.lots.length) {
                        lot = this.favorite.nb_lots;
                    }
                    this.title = 'Immeuble de ' + lot + '  lots | ' + this.favorite.ad_city.name;
                } else {
                    this.title = this.favorite.estate_type + ' | ' + this.favorite.ad_city.name;
                }
                this.sub_title = new Intl.NumberFormat('fr-FR').format(this.favorite.total_price) + ' € clé en main';

                this.favorite.description = this.favorite.description.replace(/<[^>]*>/g, '');
                this.advice_price = this.favorite.advice_price;

                var ex = this.favorite.other_comment.split(';');
                if (ex[0]) {
                    this.distance_1 = ex[0];
                }
                if (ex[1]) {
                    this.distance_1_text = ex[1];
                }
                if (ex[2]) {
                    this.distance_2 = ex[2];
                }
                if (ex[3]) {
                    this.distance_2_text = ex[3];
                }
                if (ex[4]) {
                    this.distance_3 = ex[4];
                }
                if (ex[5]) {
                    this.distance_3_text = ex[5];
                }

                var ex = this.favorite.pictures_number.split(';');
                if (ex[0]) {
                    this.photo_1 = parseInt(ex[0]);
                }
                if (ex[1]) {
                    this.photo_2 = parseInt(ex[1]);
                }
                if (ex[2]) {
                    this.photo_3 = parseInt(ex[2]);
                }
                if (ex[3]) {
                    this.photo_4 = parseInt(ex[3]);
                }
                if (ex[4]) {
                    this.photo_5 = parseInt(ex[4]);
                }
                if (ex[5]) {
                    this.photo_6 = parseInt(ex[5]);
                }
                if (ex[6]) {
                    this.photo_7 = parseInt(ex[6]);
                }
                if (ex[7]) {
                    this.photo_8 = parseInt(ex[7]);
                }


            }, error => {
                if (error != 'token_outdate') {
                    this.alertService.error('Favoris introuvable', true);
                    this.router.navigate(['/app/favorites', params.id]);
                }
            });

        });
    }

    createPdf() {
        if (!this.authenticationService.isAllowed('expert')) {

            this.trackingService.click('pdf_upgrade_open', '');
            const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                width: '520px',
                data: {visuel: 'assets/export_1.png', plan: 'Expert', feature: 'Dossier bancaire'}
            });
            this.authenticationService.currentUser.user_onboarding.popup_search_fav = true;
            this.userService.updateOnboarding(this.authenticationService.currentUser);

            dialogRef.afterClosed().subscribe(result => {
                if (result === true) {
                    this.trackingService.click('pdf_upgrade_valid', '');
                } else {
                    this.trackingService.click('pdf_upgrade_cancel', '');
                }
            });
            return;
        }
        this.loading = true;

        function filter(node) {
            return (node.className !== 'logo' && node.className !== 'fontChange');
        }

        var scale = 1;
        if (this.user.user_dashboard.pdf_quality == 'hd') {
            scale = 2;
        }
        var offsetWidth = 369 * 4;
        var offsetHeight = 206 * 4;

        console.log(this.user.user_dashboard.pdf_page);

        if (this.user.user_dashboard.pdf_page.includes('annonce')) {
            htmlToImage.toPng(document.getElementById('annonce') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgAnnonce = dataUrl;
                    this.imgDone.push('annonce');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('emplacement')) {
            htmlToImage.toPng(document.getElementById('emplacement') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgEmplacement = dataUrl;
                    this.imgDone.push('emplacement');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('distance')) {
            htmlToImage.toPng(document.getElementById('distance') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgDistance = dataUrl;
                    this.imgDone.push('distance');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('secteur')) {
            htmlToImage.toPng(document.getElementById('secteur') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgSecteur = dataUrl;
                    this.imgDone.push('secteur');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('copro')) {
            htmlToImage.toPng(document.getElementById('copro') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgCopro = dataUrl;
                    this.imgDone.push('copro');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('photo')) {
            htmlToImage.toPng(document.getElementById('photo') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgPhoto = dataUrl;
                    this.imgDone.push('photo');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('photo2')) {
            htmlToImage.toPng(document.getElementById('photo2') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgPhoto2 = dataUrl;
                    this.imgDone.push('photo2');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('photo3')) {
            htmlToImage.toPng(document.getElementById('photo3') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgPhoto3 = dataUrl;
                    this.imgDone.push('photo3');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('photo4')) {
            htmlToImage.toPng(document.getElementById('photo4') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgPhoto4 = dataUrl;
                    this.imgDone.push('photo4');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('livraison')) {
            htmlToImage.toPng(document.getElementById('livraison') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgLivraison = dataUrl;
                    this.imgDone.push('livraison');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('livraison2')) {
            htmlToImage.toPng(document.getElementById('livraison2') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgLivraison2 = dataUrl;
                    this.imgDone.push('livraison2');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('finance')) {
            htmlToImage.toPng(document.getElementById('finance') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgFinance = dataUrl;
                    this.imgDone.push('finance');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('resume')) {
            htmlToImage.toPng(document.getElementById('resume') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgResume = dataUrl;
                    this.imgDone.push('resume');
                    this.downloadPdf();
                });
        }

        if (this.user.user_dashboard.pdf_page.includes('final')) {
            htmlToImage.toPng(document.getElementById('final') as HTMLElement, {
                filter,
                quality: 1.0,
                pixelRatio: 1,
                width: offsetWidth * scale,
                height: offsetHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left',
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px'
                }
            })
                .then(dataUrl => {
                    this.imgFinal = dataUrl;
                    this.imgDone.push('final');
                    this.downloadPdf();
                });
        }
    }

    downloadPdf() {
        if (this.imgDone.length == this.user.user_dashboard.pdf_page.length) {

            const pdf = new jsPDF('l', 'cm', [20.3, 36.1]);

            const width = pdf.internal.pageSize.getWidth();
            const height = pdf.internal.pageSize.getHeight();

            console.log(width)
            console.log(height)

            pdf.addFont('assets/pdf/font/' + this.pdfConfig.font_family + '-SemiBold.ttf', '' + this.pdfConfig.font_family + '-SemiBold', 'normal');
            pdf.setFont('Gilroy-SemiBold');

            if (this.user.user_dashboard.pdf_page.includes('annonce')) {
                pdf.addPage();
                if (this.favorite.visite_link != "") {
                    pdf.link(15, 16, 5.8, 2.2, {url: this.favorite.visite_link});
                }
                pdf.addImage(this.imgAnnonce, 'PNG', 0, 0, width, height, null, 'MEDIUM');
            }

            // Title (dont take user modification)
            pdf.addFont('assets/pdf/font/' + this.pdfConfig.font_family + '-SemiBold.ttf', '' + this.pdfConfig.font_family + '-SemiBold', 'normal');
            pdf.setFont('' + this.pdfConfig.font_family + '-SemiBold');
            pdf.setTextColor(this.pdfConfig.text_color);
            pdf.setFontSize(8);
            // pdf.setFontSize(22);
            // pdf.text(this.favorite.estate_type + ' | ' + this.favorite.rooms + ' pièces | ' + this.favorite.square + 'm2', 220, 150, {align: 'center'});

            const height_small_logo = 20;
            const with_small_logo = this.pdfConfig.logo_small_w / (this.pdfConfig.logo_small_h / height_small_logo);
            let x = 20;
            if (this.pdfConfig.logo_small_style.includes('center')) {
                x = (width - with_small_logo) / 2;
            }

            if (this.user.user_dashboard.pdf_page.includes('emplacement')) {
                pdf.addPage();
                pdf.addImage(this.imgEmplacement, 'PNG', 0, 0, width, height, null, 'MEDIUM');
            }
            if (this.user.user_dashboard.pdf_page.includes('distance')) {
                pdf.addPage();
                pdf.addImage(this.imgDistance, 'PNG', 0, 0, width, height, null, 'MEDIUM');
            }
            if (this.user.user_dashboard.pdf_page.includes('secteur')) {
                pdf.addPage();
                pdf.addImage(this.imgSecteur, 'PNG', 0, 0, width, height, null, 'MEDIUM');
            }
            if (this.user.user_dashboard.pdf_page.includes('copro')) {
                pdf.addPage();
                pdf.addImage(this.imgCopro, 'PNG', 0, 0, width, height, null, 'MEDIUM');
            }
            if (this.user.user_dashboard.pdf_page.includes('photo')) {
                pdf.addPage();
                pdf.addImage(this.imgPhoto, 'PNG', 0, 0, width, height, null, 'MEDIUM');
            }
            if (this.user.user_dashboard.pdf_page.includes('photo2')) {
                pdf.addPage();
                pdf.addImage(this.imgPhoto2, 'PNG', 0, 0, width, height, null, 'MEDIUM');
            }
            if (this.user.user_dashboard.pdf_page.includes('photo3')) {
                pdf.addPage();
                pdf.addImage(this.imgPhoto3, 'PNG', 0, 0, width, height, null, 'MEDIUM');
            }
            if (this.user.user_dashboard.pdf_page.includes('photo4')) {
                pdf.addPage();
                pdf.addImage(this.imgPhoto4, 'PNG', 0, 0, width, height, null, 'MEDIUM');
            }
            if (this.user.user_dashboard.pdf_page.includes('livraison')) {
                pdf.addPage();
                pdf.addImage(this.imgLivraison, 'PNG', 0, 0, width, height, null, 'MEDIUM');
            }
            if (this.user.user_dashboard.pdf_page.includes('livraison2')) {
                pdf.addPage();
                pdf.addImage(this.imgLivraison2, 'PNG', 0, 0, width, height, null, 'MEDIUM');
            }
            if (this.user.user_dashboard.pdf_page.includes('finance')) {
                pdf.addPage();
                pdf.addImage(this.imgFinance, 'PNG', 0, 0, width, height, null, 'MEDIUM');
            }
            if (this.user.user_dashboard.pdf_page.includes('resume')) {
                pdf.addPage();
                pdf.addImage(this.imgResume, 'PNG', 0, 0, width, height, null, 'MEDIUM');
            }
            if (this.user.user_dashboard.pdf_page.includes('final')) {
                pdf.addPage();
                pdf.addImage(this.imgFinal, 'PNG', 0, 0, width, height, null, 'MEDIUM');
            }

            pdf.deletePage(1);
            pdf.save(this.favorite.title + '.pdf');

            // Save export date
            this.http.put(`${environment.apiUrl}app/favorite/${this.favorite.id}/export`, {}).subscribe(result => {
                this.alertService.success('Export terminé');
            }, error => {
                console.log(error);
            });
            this.imgAnnonce = '';
            this.imgSecteur = '';
            this.imgFinance = '';
            this.imgPatrimoniale = '';
            this.imgDone = [];
            this.loading = false;
        }
    }

    setPriceEvolData() {

        if (this.favorite.ad_city.city_code === '') {
            return;
        }
        const dataAdep = [];
        const dataMdep = [];
        const dataAville = [];
        const dataMville = [];

        this.priceEvolOptions.xAxis.data = PRICE_EVOL_LEGENT;
        this.priceEvolOptions.xAxis.data.forEach(keys => {

            if (this.favorite.ad_city.prix_departement.A != null && this.favorite.ad_city.prix_departement.A[keys] !== undefined) {
                dataAdep.push(this.favorite.ad_city.prix_departement.A[keys].pM);
                if (this.priceEvolOptions.yAxis.min > (this.favorite.ad_city.prix_departement.A[keys].pM * 0.8)) {
                    this.priceEvolOptions.yAxis.min = Math.round(this.favorite.ad_city.prix_departement.A[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataAdep.push('');
            }

            if (this.favorite.ad_city.prix_departement.M != null && this.favorite.ad_city.prix_departement.M[keys] !== undefined) {
                dataMdep.push(this.favorite.ad_city.prix_departement.M[keys].pM);
                if (this.priceEvolOptions.yAxis.min > (this.favorite.ad_city.prix_departement.M[keys].pM * 0.8)) {
                    this.priceEvolOptions.yAxis.min = Math.round(this.favorite.ad_city.prix_departement.M[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataMdep.push('');
            }

            if (this.favorite.ad_city.prix_ville.A != null && this.favorite.ad_city.prix_ville.A[keys] !== undefined) {
                dataAville.push(this.favorite.ad_city.prix_ville.A[keys].pM);
                if (this.priceEvolOptions.yAxis.min > (this.favorite.ad_city.prix_ville.A[keys].pM * 0.8)) {
                    this.priceEvolOptions.yAxis.min = Math.round(this.favorite.ad_city.prix_ville.A[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataAville.push('');
            }

            if (this.favorite.ad_city.prix_ville.M != null && this.favorite.ad_city.prix_ville.M[keys] !== undefined) {
                dataMville.push(this.favorite.ad_city.prix_ville.M[keys].pM);
                if (this.priceEvolOptions.yAxis.min > (this.favorite.ad_city.prix_ville.M[keys].pM * 0.8)) {
                    this.priceEvolOptions.yAxis.min = Math.round(this.favorite.ad_city.prix_ville.M[keys].pM * 0.8 / 100) * 100;
                }
            } else {
                dataMville.push('');
            }
        });

        this.priceEvolData.series.push({
            name: this.favorite.ad_city.departement + ' : Appartement',
            type: 'line',
            data: dataAdep
        });

        this.priceEvolData.series.push({
            name: this.favorite.ad_city.departement + ' : Maison',
            type: 'line',
            data: dataMdep
        });

        this.priceEvolData.series.push({
            name: this.favorite.ad_city.name + ' : Appartement',
            type: 'line',
            data: dataAville
        });

        this.priceEvolData.series.push({
            name: this.favorite.ad_city.name + ' : Maison',
            type: 'line',
            data: dataMville
        });

        this.priceEvolOptions.legend.selected = {
            [this.favorite.ad_city.departement + ' : Appartement']: dataAville.filter(Boolean).length < 1,
            [this.favorite.ad_city.departement + ' : Maison']: dataMville.filter(Boolean).length < 1,
            [this.favorite.ad_city.name + ' : Appartement']: dataAville.filter(Boolean).length >= 1,
            [this.favorite.ad_city.name + ' : Maison']: dataMville.filter(Boolean).length >= 1,
        };
    }

    setChargeData() {
        let data = {
            series: [
                {
                    right: '20%',
                    name: '',
                    type: 'pie',
                    radius: ['60%', '90%'],
                    avoidLabelOverlap: false,
                    fontSize: 30,
                    itemStyle: {
                        borderRadius: 10,
                        borderColor: '#fff',
                        borderWidth: 2
                    },
                    data: [],
                    labelLine: {
                        show: false
                    },
                    label: {
                        show: false,
                        position: 'center'
                    },
                }
            ]
        };

        if (this.favorite.monthly > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.monthly), name: 'Mensualité'});
        }
        if (this.favorite.amount_property_tax > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.amount_property_tax / 12), name: 'Taxe foncière'});
        }
        if (this.favorite.agence_rental / 12 + (this.favorite.agence * this.favorite.amount_rent) > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.agence_rental / 12 + (this.favorite.agence * this.favorite.amount_rent) / 100), name: 'Gestion en agence'});
        }
        if (this.favorite.amount_copro > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.amount_copro / 12), name: 'Charges de copro'});
        }
        if (this.favorite.amount_rent_insurance > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.amount_rent_insurance * this.favorite.amount_rent / 100), name: 'GLI'});
        }
        if (this.favorite.building_insurance > 0) {
            data.series[0].data.push({value: Math.round(this.favorite.building_insurance / 12), name: 'Assurance PNO'});
        }
        if (this.favorite.cash_flow > 0) {
            data.series[0].data.push({value: Math.round((this.favorite.cash_flow > 0) ? this.favorite.cash_flow : 0), name: 'Cash flow'});
        }

        this.chargeData = data;

        if (this.favorite.other_bill > 0) {
            this.chargeData.series[0].data.push({value: Math.round(this.favorite.other_bill / 12), name: 'Autres frais'});
        }
        if (this.favorite.accouting_fees + this.favorite.cfe_contribution + this.favorite.cga_contribution > 0) {
            this.chargeData.series[0].data.push({value: Math.round((this.favorite.accouting_fees + this.favorite.cfe_contribution + this.favorite.cga_contribution) / 12), name: 'Frais de comptabilités'});
        }
    }

    setPopData() {

        this.popOptions.yAxis.min = 1000000;
        this.popOptions.xAxis.data = [];

        const dataPop = [];
        Object.keys(this.favorite.ad_city.demographie_annuelle).forEach(keys => {
            if (keys !== 'Cr') {
                dataPop.push(this.favorite.ad_city.demographie_annuelle[keys]);
                this.popOptions.xAxis.data.push(keys);
                if (this.popOptions.yAxis.min > (this.favorite.ad_city.demographie_annuelle[keys] * 0.9)) {
                    this.popOptions.yAxis.min = Math.round(this.favorite.ad_city.demographie_annuelle[keys] * 0.9 / 1000 - 1) * 1000;
                }
            }
        });
        this.popData = {
            series: [
                {
                    name: this.favorite.ad_city.name,
                    type: 'bar',
                    data: dataPop,
                },
            ]
        };

        if (this.popEchartsIntance) {
            this.popEchartsIntance.setOption(this.popOptions);
        }
    }

    callImpot() {

        this.favorite = this.adService.cleanInput(this.favorite);
        this.favorite = this.adService.updateValues(this.favorite);

        const fav = this.adService.cleanForImpot(this.favorite, this.user);

        if (fav.fiscal_choice !== '' && fav.price > 0 && fav.amount_rent > 0) {
            fav.is_credit_differed = false;
            this.http.post<any>(environment.impotUrl, fav)
                .subscribe(data => {
                    if (data.comparatif[fav.fiscal_choice] != undefined && data.comparatif[fav.fiscal_choice].enrichment !== undefined) {
                        this.enrichment = data.comparatif[fav.fiscal_choice].enrichment;
                    }
                    if (data[fav.fiscal_choice].cols !== undefined) {

                        // Graphique compraison des régimes fiscaux
                        if (this.favorite.selling == true) {
                            this.result = data[fav.fiscal_choice].impots.slice(0, this.favorite.selling_year);
                        } else {
                            this.result = data[fav.fiscal_choice].impots;
                        }

                        // 5 dernier + X premier
                        // if (this.result.length > 19) {
                        //     this.result = this.result.slice(0, 19 - 5).concat(this.result.slice(this.result.length - 5, this.result.length));
                        // }

                        if (this.result[this.result.length - 1].loyers_percus > 99999 || this.favorite.total_price > 999999) {
                            this.hideUnit = true;
                        }
                        this.displayedColumns = data[fav.fiscal_choice].cols;

                        // Graphique Evolution du capital net
                        this.data_CF_cum = [];
                        const data_Amortissement = [];
                        const data_Enrich = [];

                        var cumul = 0;
                        Object.keys(this.result).forEach(keys => {
                            if (parseInt(keys, 10) < this.favorite.duration) {
                                cumul = cumul + Math.round(this.result[keys].cash_flow);
                                this.data_CF_cum.push(cumul);

                                data_Amortissement.push(Math.round(this.favorite.total_price - this.favorite.apport - this.result[keys].capital_restant_du));
                                data_Enrich.push(Math.round(this.favorite.total_price - this.favorite.apport - this.result[keys].capital_restant_du) + cumul);
                                if (parseInt(keys, 10) == 9) { // 10eme année
                                    this.enrichment_10 = Math.round(this.favorite.total_price - this.favorite.apport - this.result[keys].capital_restant_du) + cumul;
                                }

                                this.amort_moy = Math.round((this.favorite.total_price - this.result[keys].capital_restant_du) / this.favorite.duration);
                            }
                        });

                        var d = this.favorite.duration;
                        if (this.favorite.selling == true) {
                            d = this.favorite.selling_year;
                        }
                    }

                    setTimeout(function() {
                        this.ready = true;
                    }.bind(this), 5000);


                }, err => {
                    console.log(err);
                });
        } else {
            this.alertService.error('Informations manquante pour la fiscalite.');
        }
    }

    onPriceChartInit(ec) {
        this.priceEvolEchartsIntance = ec;
    }

    onChargeChartInit(ec) {
        this.chargeEchartsIntance = ec;
    }

    onChartPopInit(ec) {
        this.popEchartsIntance = ec;
    }

    edit(event, fields = '') {
        if (fields == 'description') {
            this.adService.updateFavoriteText(this.favorite, this.favorite.description, fields);
        } else if (fields == 'comment_city') {
            this.adService.updateFavoriteText(this.favorite, this.favorite.comment_city, fields);
        } else if (fields == 'comment_copro') {
            this.adService.updateFavoriteText(this.favorite, this.favorite.comment_copro, fields);
        } else if (fields == 'comment_work') {
            this.adService.updateFavoriteText(this.favorite, this.favorite.comment_work, fields);
        } else if (fields == 'comment') {
            this.adService.updateFavoriteText(this.favorite, this.favorite.comment, fields);
        } else if (fields == 'distance') {
            this.adService.updateFavoriteText(this.favorite, this.distance_1 + ';' + this.distance_1_text + ';' + this.distance_2 + ';' + this.distance_2_text + ';' + this.distance_3 + ';' + this.distance_3_text, 'other_comment');
        } else if (fields == 'pictures') {
            this.adService.updateFavoriteText(this.favorite, this.photo_1 + ';' + this.photo_2 + ';' + this.photo_3 + ';' + this.photo_4 + ';' + this.photo_5 + ';' + this.photo_6 + ';' + this.photo_7 + ';' + this.photo_8, fields);
        } else {
            this.adService.updateFavorite(this.favorite);
        }
    }

    onPageChange(val) {
        if (_.difference(val, this.user.user_dashboard.pdf_page).length !== 0) {
            // Checked
            this.user.user_dashboard.pdf_page = _.without(this.user.user_dashboard.pdf_page, 'action');
            this.user.user_dashboard.pdf_page.push(_.difference(val, this.user.user_dashboard.pdf_page)[0]);
        } else if (_.difference(this.user.user_dashboard.pdf_page, val).length !== 0) {
            // Unchecked
            this.user.user_dashboard.pdf_page = _.without(this.user.user_dashboard.pdf_page, _.difference(this.user.user_dashboard.pdf_page, val)[0]);
        }
        this.updateDashboard();
    }

    updateDashboard() {
        this.userService.updateDashboard(this.user);
    }

    openPageSelection() {
        $('#pageSelection .isMinimizable').toggleClass('minimize');
    }

    openDropdown() {
        $('#optionDropdown').addClass('optionDropdownOnboarding');
    }
}
